import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AddSeries, UpdateSeries } from './series.interface';

@Injectable({
    providedIn: 'root',
})
export class SeriesService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie.listDT;

    private findURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie.find;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie.update;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie
            .public;

    private updateNumarCurentUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie
            .updateNumarCurent;

    private newNumbersBlockUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie
            .newNumbersBlock;

    private changeStatusArchiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.serie
            .archive;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddSeries) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: UpdateSeries) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    updateNumarCurent(id: number, payload: { current_number: number }) {
        return this.http.put(this.updateNumarCurentUrl + id, payload, this.httpOptions);
    }

    updateNewNumbersBlock(id: number) {
        return this.http.put(this.newNumbersBlockUrl + id, {}, this.httpOptions);
    }

    changeStatusArchive(id: number) {
        return this.http.put(this.changeStatusArchiveUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
